import React, { useMemo, useState } from "react";

type Props = {
  name: string;
  value?: string;
  tag?: string;
};

export const Phone: React.FC<Props> = ({ name, value, tag }) => {
  const countries = JSON.parse(document.querySelector("[data-countries]")?.innerHTML);

  const [cc, setCC] = useState(value?.includes("+64") ? "NZ" : value?.includes("+1") ? "US" : "AU");
  const [ccVal, setCcVal] = useState(value?.includes("+64") ? "+64" : value?.includes("+1") ? "+1" : "+61");
  const [fullValue, setFullValue] = useState(value);
  const [localValue, setLocalValue] = useState(fullValue?.replace("+61", "")?.replace("+64", "")?.replace("+1", ""));

  const onSelectChange = (e) => {
    setCC(e.target.querySelector("option:checked")?.getAttribute("data-cc"));
    setCcVal(e.target.value);
    setFullValue(e.target.value + localValue);
  };

  const onInputChange = (e) => {
    setLocalValue(e.target.value);
    setFullValue(ccVal + e.target.value);
  };

  const imgSrc = useMemo(() => {
    return countries.find((x) => x.cc === cc)?.img;
  }, [countries, ccVal]);

  return (
    <div className="_field">
      <input type="hidden" name={name} value={fullValue} data-tag={tag} />

      <div className="_field _field--with-select  phone_field">
        <div className="_field__select">
          <img src={imgSrc} alt="flag" />
          <span>{ccVal}</span>
          <div className="_field__button" aria-label="Phone">
            <ui-icon name="icon-chevron-down-small"></ui-icon>
          </div>

          <select defaultValue={ccVal} onChange={onSelectChange}>
            <option value="+61" data-cc="AU">
              Australia
            </option>
            <option value="+64" data-cc="NZ">
              New Zealand
            </option>
            <option value="+1" data-cc="US">
              USA
            </option>
          </select>
        </div>

        <div className="_field _field--text _field-phone">
          <input
            type="tel"
            id="Register-phone-1_drawer"
            className="_field__input"
            autoComplete="tel"
            pattern="[0-9\-]*"
            placeholder="Phone"
            onChange={onInputChange}
            value={localValue}
          />
          <label className="_field__label" htmlFor="Register-phone-1_drawer">
            Phone
          </label>
        </div>
      </div>
    </div>
  );
};
